window.addEventListener('load', () => {
    let priceSlider = document.querySelector('#price_range')
    let minInput = document.querySelector('#price_min')
    let maxInput = document.querySelector('#price_max')
    let sliding = false

    if(priceSlider) {
        let min = Number(priceSlider.dataset.min)
        let max = Number(priceSlider.dataset.max)
        let min_value = Number(minInput.mask.unmaskedValue)
        let max_value = Number(maxInput.mask.unmaskedValue)

        priceSlider.innerHTML = ''
        
        let slider = noUiSlider.create(priceSlider, {
            range: {min, max},
            step: 1,
            start: [min_value, max_value],
            connect: true,
        })

        slider.on('slide', () => {
            let values = slider.get()

            if(minInput) {
                minInput.mask.unmaskedValue = values[0]
            }

            if(maxInput) {
                maxInput.mask.unmaskedValue = values[1]
            }
        })

        slider.on('start', () => {
            sliding = true

            allowOut = false
        })

        slider.on('end', () => {
            sliding = false

            attachFloationgButton(priceSlider)
        })

        if(minInput) {
            minInput.mask.on('accept', () => {
                if(!sliding) {
                    let price = Number(minInput.mask.unmaskedValue)
                    let values = slider.get()
    
                    values[0] = price
                    slider.set(values)

                    attachFloationgButton(priceSlider)
                }
            })
        }

        if(maxInput) {
            maxInput.mask.on('accept', () => {
                if(!sliding) {
                    let price = Number(maxInput.mask.unmaskedValue)
                    let values = slider.get()
    
                    values[1] = price
                    slider.set(values)

                    attachFloationgButton(priceSlider)
                }
            })
        }

        window.priceSlider = slider
    }
})

/////

window.addEventListener('load', () => {
    let archiveSidebar = document.querySelector('.archive-sidebar')
    let toggleArchiveSidebar = document.querySelector('.toggle-archive-sidebar')
    let closeArchiveSidebar = document.querySelector('.close-archive-sidebar')

    if(archiveSidebar && toggleArchiveSidebar && closeArchiveSidebar) {
        archiveSidebar.classList.add('loaded')

        toggleArchiveSidebar.addEventListener('click', () => {
            archiveSidebar.classList.toggle('show')
        })

        closeArchiveSidebar.addEventListener('click', () => {
            archiveSidebar.classList.remove('show')
        })
    }
})

/////

if(window.innerWidth < 768) {
    let appliedFilters = document.querySelector('.applied .line')

    if(appliedFilters) {
        let items = appliedFilters.querySelectorAll('.applied-filter')
        let wrapper = document.createElement('div')

        wrapper.classList.add('swiper-wrapper')

        for(let item of items) {
            wrapper.appendChild(item)
        }

        appliedFilters.appendChild(wrapper)

        new Swiper(appliedFilters, {
            slideClass: 'applied-filter',
            loop: false,
            speed: 600,
            slidesPerView: 'auto',
            spaceBetween: 15,
        })
    }
}

/////

let categoriesSlider = document.querySelector('.categories-slider')

if(categoriesSlider) {
    new Swiper(categoriesSlider, {
        slideClass: 'category',
        loop: false,
        speed: 600,
        slidesPerView: 'auto',
        spaceBetween: 20,
    })
}

/////

let loadMore = document.querySelector('#load_more')

if(loadMore) {
    let page = Number(loadMore.dataset.page)

    loadMore.addEventListener('click', () => {
        let wrapper = loadMore.parentElement
        let max = Number(loadMore.dataset.max)
        let urlObject = new URL(window.location.href)
        let url = urlObject.href
        let search = urlObject.searchParams.get('s') || ''
        let filters = getFilters()
        let sort = getSort() || ''

        search = String(search)

        page++
        loadMore.disable(true)

        urlObject.searchParams.set('pag', page)
        window.history.replaceState('', '', urlObject.href)

        let data = {page, url, search, filters, sort}

        console.log(data);

        requestAxios('loadMore', data, (res) => {
            wrapper.insertAdjacentHTML('beforebegin', res)
            initFavBtns()
            addToCartBtn()

            if(max == page) {
                wrapper.remove()
            } else {
                loadMore.enable()
            }
            
        })
    })
}